import { z } from 'zod';

const coordinatesSchema = z.object({
  level: z.number(),
  bay: z.number(),
  position: z.number(),
});

const locationCapabilitiesSchema = z.object({
  allowsMixedProducts: z.boolean(),
  allowsMixedLots: z.boolean(),
  isPickingLocation: z.boolean(),
  stackable: z.boolean(),
});

const zoneInfoSchema = z.object({
  _id: z.string(),
  code: z.string(),
  name: z.string(),
  type: z.string().optional().default(''),
  color: z.string().optional().default(''),
});

const rackInfoSchema = z.object({
  _id: z.string(),
  code: z.string(),
  name: z.string(),
  type: z.string().optional().default(''),
});

export const locationListItemSchema = z.object({
  _id: z.string(),
  code: z.string(),
  type: z.string(),
  status: z.string(),
  coordinates: coordinatesSchema,
  isPickingLocation: z.boolean(),
  capabilities: locationCapabilitiesSchema,
  zone: zoneInfoSchema,
  rack: rackInfoSchema,
});

export const locationsListResponseSchema = z.object({
  data: z.array(locationListItemSchema),
  page: z.number(),
  limit: z.number(),
  total: z.number(),
  totalPages: z.number(),
});

export const transferLocationSearchRowSchema = locationListItemSchema.extend({
  search: z.string(),
});

export type LocationListItem = z.infer<typeof locationListItemSchema>;
export type LocationsListResponse = z.infer<typeof locationsListResponseSchema>;
export type TransferLocationSearchRow = z.infer<typeof transferLocationSearchRowSchema>;
